import { render } from "./heatmap.vue?vue&type=template&id=b6ff9936&scoped=true"
import script from "./heatmap.vue?vue&type=script&lang=js"
export * from "./heatmap.vue?vue&type=script&lang=js"

import "./heatmap.vue?vue&type=style&index=0&id=b6ff9936&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ff9936"]])

export default __exports__